require('../../modules/es6.array.reduce');
module.exports = require('../../modules/_core').Array.reduce;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/fn/array/reduce.js
// module id = 1074
// module chunks = 0